export default __webpack_public_path__ + "static/media/success-fulCases3.1164860d.png";